{
  "title": "Finger of Death",
  "source": "Player's Handbook",
  "levelAndSchool": "7th-level necromancy",
  "level": 7,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You send negative energy coursing through a creature that you can see within range, causing it searing pain. The target must make a Constitution saving throw. It takes 7d8 + 30 necrotic damage on a failed save, or half as much damage on a successful one.",
    "A humanoid killed by this spell rises at the start of your next turn as a zombie that is permanently under your command, following your verbal orders to the best of its ability."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
